import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import decode from "jwt-decode";
import axios from "axios";
import Header from "../Header/Header";
import { Button, Form, FormGroup, Label, Input, Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { AuthContext } from "../../contexts/AuthContext";
import Footer from "../Footer/Footer";
import "./Login.css";
// import logo from "./Logo.png";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loginUser, user } = useContext(AuthContext);
  const history = useHistory();
  const [text, setText] = useState(false);
  const [loading, setLoading] = useState(true);
  const [estadoPago, setEstadoPago] = useState("Activo");

  // Corriente: Activo
  // Antes del 10: Aviso
  // Moroso: Suspendido

   function handleClick() {
    history.push("/Inicio");
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const jsonSend = {
      email,
      password,
    };
    const LOGIN_URL = process.env.REACT_APP_URL_LOGIN;
    try {
      const res = await axios.post(LOGIN_URL, jsonSend);
      loginUser(res.data.token);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Bienvenido",
        showConfirmButton: false,
        timer: 2000,
      });
      // Si el usuario NO tiene Menú Usuarios (solo Lugares Fiestas), va directo a ese módulo
      let destino = "/Inicio";
      try {
        const decoded = decode(res.data.token);
        if (decoded && decoded.menu_usuarios === false) destino = "/LugaresFiestas";
      } catch (e) { /* usa /Inicio por defecto */ }
      history.push(destino);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al iniciar sesión",
        text: error?.response?.data?.message || "Usuario o contraseña incorrectos",
      });
    }
  };

  // return (
  //   <>
  //     {/* <Header /> */}
  //     <div className="container d-flex justify-content-center align-items-center vh-100">
  //     <div className="col-sm-5">
  //       <Card className="shadow-lg p-4 text-center">
  //         <img
  //           src={process.env.PUBLIC_URL + "/Logo-Lynqro-Login.png"}
  //           className="mb-3"
  //           style={{ width: "100%", maxHeight: "180px", objectFit: "contain" }}
  //           alt="Lynqro Logo"
  //         />
  //         <CardBody>
  //           <CardTitle tag="h3" style={{ color: "red" }}>
  //             Saldo Pendiente
  //           </CardTitle>
  //           <p className="text-muted">
  //             Notamos que tienes un saldo pendiente en tu cuenta. Para continuar
  //             con el acceso, te invitamos a regularizarlo lo antes posible.
  //           </p>
  //           <p className="text-muted">
  //             Si necesitas más información o ayuda con tu pago, contáctanos.
  //           </p>
  //           <p className="text-muted">
  //             Gracias por tu comprensión.
  //           </p>

               
  //         </CardBody>
  //       </Card>
  //     </div>
  //   </div>
  //   </>
  // );

  return (
    <>
      {estadoPago === "Aviso" ? (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-white">
          <div
            className="card p-4 shadow-lg rounded-4"
            style={{ maxWidth: "400px", width: "100%" }}
          >
            <div className="text-center">
              <img
                src={process.env.PUBLIC_URL + "/Logo-Lynqro-Login.png"}
                className="img-fluid mb-3"
                style={{ maxHeight: "180px" }}
                alt="Lynqro Logo"
              />
            </div>

            {loading ? (
              <div className="text-center">
                <h2 className="text-danger fw-bold">Aviso</h2>
                <h4 className="text-danger fw-bold">
                  ⚠️ Te recordamos que para mantener tu servicio activo, es
                  importante que te pongas al corriente con tus pagos antes del
                  día 10. Si necesitas apoyo o tienes alguna duda, estamos aquí
                  para ayudarte.
                </h4>
                <Button
                  color="danger"
                  className="mt-3 fw-bold"
                  onClick={() => setEstadoPago("")}
                >
                  Cerrar
                </Button>
              </div>
            ) : (
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label className="fw-bold">Email</Label>
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Escribe tu email"
                    className="p-2"
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label className="fw-bold">Password</Label>
                  <Input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    placeholder="Escribe tu contraseña"
                    className="p-2"
                    required
                  />
                </FormGroup>
                <div className="d-grid mt-3">
                  <Button color="primary" className="fw-bold">
                    Login
                  </Button>
                </div>
              </Form>
            )}
          </div>
        </div>
      ) : estadoPago === "Suspendido" ? (
        <div className="container d-flex justify-content-center align-items-center vh-100">
          <div className="col-sm-5">
            <Card className="shadow-lg p-4 text-center">
              <img
                src={process.env.PUBLIC_URL + "/Logo-Lynqro-Login.png"}
                className="mb-3"
                style={{
                  width: "100%",
                  maxHeight: "180px",
                  objectFit: "contain",
                }}
                alt="Lynqro Logo"
              />
              <CardBody>
                <CardTitle tag="h3" style={{ color: "red" }}>
                  Saldo Pendiente
                </CardTitle>
                <p className="text-muted">
                  Notamos que tienes un saldo pendiente en tu cuenta. Para
                  continuar con el acceso, te invitamos a regularizarlo lo antes
                  posible.
                </p>
                <p className="text-muted">
                  Si necesitas más información o ayuda con tu pago, contáctanos.
                </p>
                <p className="text-muted">Gracias por tu comprensión.</p>
              </CardBody>
            </Card>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-white">
          <div
            className="card p-4 shadow-lg rounded-4"
            style={{ maxWidth: "400px", width: "100%" }}
          >
            <div className="text-center">
              <img
                src={process.env.PUBLIC_URL + "/Logo-Lynqro-Login.png"}
                className="img-fluid mb-3"
                style={{ maxHeight: "180px" }}
                alt="Lynqro Logo"
              />
            </div>

            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label className="fw-bold">Email</Label>
                <Input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Escribe tu email"
                  className="p-2"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label className="fw-bold">Password</Label>
                <Input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="Escribe tu contraseña"
                  className="p-2"
                  required
                />
              </FormGroup>
              <div className="d-grid mt-3">
                <Button color="primary" className="fw-bold">
                  Login
                </Button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </>
  );
  
};

export default Login;
